<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="height:880px;overflow:auto;borderLeft:1px solid #C3C2C1;">
        <el-main>
          <el-row style="justify-content:left;padding-bottom:5px;">
            <el-button color="#EEEEEC" type="primary" class="operation-btn" @click="get_dls()">更新</el-button>
          </el-row>
          <div v-if="tableData.length != 0">
            <el-table :data="tableData" stripe height="700" style="min-width:810px;">
              <el-table-column label="" :width="headerWidth" />
              <el-table-column label="DL名" prop="name" />
              <el-table-column label="牛房" prop="barns">
                <template #default="scope">
                  <div v-for="(barn) in scope.row.barns" v-bind:key="barn" class="font_16"
                    v-bind:style="{ lineHeight: barn.barn_height * 23 + 'px' }">
                    {{ barn.barn_name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="カメラ" prop="barns">
                <template #default="scope">
                  <div v-for="(barn) in scope.row.barns" v-bind:key="barn">
                    <div v-for="(cam) in barn.cameras" v-bind:key="cam" class="font_16">
                      {{ cam.camera_name }}
                    </div>
                    <div v-if="barn.cameras.length == 0">
                      &emsp;
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="バージョン">
                <template #default="scope">
                  <div v-if="scope.row.system_version_info !== ''" class="font_16">{{ scope.row.system_version_info }}
                  </div>
                  <div v-if="scope.row.system_version_info === ''">&emsp;</div>
                  <div v-if="scope.row.message !== ''" class="font_14">{{ scope.row.message }}</div>
                  <div v-if="scope.row.message === ''">&emsp;</div>
                </template>
              </el-table-column>
              <el-table-column label="" width="145px">
                <template #default="scope">
                  <el-button class="button-style" color="#ffdf5e" style="width:132px;margin-left:3px;margin-bottom:3px;"
                    round type="primary" @click="set_system_update(scope.row.id)" :disabled="!scope.row.button_enable">
                    {{ scope.row.button_caption }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="" width="190px">
                <template #default="scope">
                  <div class="font_14" style="width:182px;color:red;padding: 0;">
                    {{ scope.row.status_message }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="" width="24px">
                <template #default="scope">
                  <div
                    v-bind:style="{ width: '100%', height: scope.row.max_lines * 23 + 'px', paddingTop: '8px', paddingRight: '5px', position: 'relative' }">
                    <el-badge :is-dot="scope.row.software_update_ready"
                      style="right: 1em;position:absolute;top:6px;left:6px;">
                      <div></div>
                    </el-badge>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="!loading & (tableData.length == 0)">
            <el-row class="width100">
              <el-row class="width100" style="justify-content:center;margin-top:20%;">
                <p class="font_18 font_bold">登録されている検知システムがありません</p>
              </el-row>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

export default {
  name: 'SystemUpdateView',
  components: {
    HeaderView,
    MenuView
  },
  created() {
    this.$store.commit('setCowMenuSelect', '> 検知システムアップデート');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
    this.hoverCssDelete();
  },
  beforeUnmount() {
    this.hoverCssInsert();
  },
  data() {
    return {
      userType: ConstParam.disable_user_kind,
      headerWidth: "96px",
      saveStyle: [],
      dlsData: [],
      tableData: [
        {
          start: "",
          end: ""
        }
      ],
      barnsData: [],
      camerasData: [],
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: true,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    getErrorMessage(res) {
      if (
        'message' in res &&
        'response' in res.message &&
        'data' in res.message.response &&
        'message' in res.message.response.data
      ) {
        return res.message.response.data.message
      } else {
        return ""
      }
    },
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    hoverCssDelete() {
      this.saveStyle = [];
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.cssRules) continue;
        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.cssRules[ri].selectorText) continue;

          if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
            if (styleSheet.cssRules[ri].selectorText.indexOf('.el-table') != -1) {
              let tempStyle = styleSheet.cssRules[ri];
              this.saveStyle.push(tempStyle['cssText']);
              styleSheet.deleteRule(ri);
            }
          }
        }
      }
    },
    hoverCssInsert() {
      for (let i = 0; i < this.saveStyle.length; i++) {
        document.styleSheets.item(0).insertRule(this.saveStyle[i]);
      }
    },
    set_system_update(dl_id) {
      let message = "アップデート中は、カメラが停止します。\nアップデートしてよろしいですか？";
      this.$confirm(message, "", {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.setSystemUpdate(dl_id);
      }).catch(() => {
        return
      });
    },
    setSystemUpdate: async function (dl_id) {
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.controlDl(dl_id, "", "", "", "", "", true)
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.viewMessage("検知システムアップデートを開始しました。", "success");
          }
          this.get_dls();
        });
    },
    getBarnInfo(barn_id) {
      let tempRes = null;
      for (let idx = 0; idx < this.barnsData.length; idx++) {
        if (barn_id === this.barnsData[idx].barn_id) {
          tempRes = {
            barn_id: this.barnsData[idx].barn_id,
            barn_name: this.barnsData[idx].barn_name,
            barn_height: 1,
            cameras: []
          }
          if ("cameras" in this.barnsData[idx]) {
            let tempCameras = [];
            for (let idy = 0; idy < this.barnsData[idx]['cameras'].length; idy++) {
              const tempCameraName = {
                camera_name: this.barnsData[idx]['cameras'][idy].camera_name
              }
              tempCameras.push(tempCameraName);
            }
            tempRes.cameras = tempCameras;
            if (tempCameras.length > 0) {
              tempRes.barn_height = tempCameras.length;
            }
          }
        }
      }
      return tempRes;
    },
    get_dls: async function () {
      this.loading = true;
      await AWSAPI.getFarmerDls(this.farmer_id)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.dlsData = res['data']['data'];
          }
        });
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
    // ==================
  },
  watch: {
    userData: function () {
      this.barnsData = [];
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      if ('farmer' in this.userData && 'barns' in this.userData['farmer']) {
        this.barnsData = JSON.parse(JSON.stringify((this.userData['farmer']['barns'])));
      }
      if ('farmer' in this.userData && 'dls' in this.userData['farmer']) {
        this.dlsData = JSON.parse(JSON.stringify((this.userData['farmer']['dls'])));
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      this.loading = false;
    },
    dlsData: function () {
      this.tableData = [];
      for (let idx = 0; idx < this.dlsData.length; idx++) {
        let tempBarn = []
        let tempMaxLines = 0;
        if ("barn_id" in this.dlsData[idx]) {
          for (let idy = 0; idy < this.dlsData[idx]['barn_id'].length; idy++) {
            const tempBarnInfo = this.getBarnInfo(this.dlsData[idx]['barn_id'][idy]);
            tempBarn.push(tempBarnInfo);
            tempMaxLines += tempBarnInfo.barn_height;
          }
        }
        if (tempMaxLines == 0) {
          tempMaxLines = 1;
        }
        let tempSystemVersionInfo = "";
        let tempSoftwareVersion = "";
        let tempSystemUpdateCmplete = false;
        let tempSystemVersionTime = "";
        let tempSoftwareUpdateReady = false;
        let tempUpdateStatus = 0;
        let tempUpdateStatusTimeout = -1;
        let tempUpdateStatusDetail = "";
        let tempUpdateEnable = false;
        let tempSystemMessage = "";
        let tempStatusMessage = "";
        let tempButtonCaption = "アップデート";
        if ("software_version" in this.dlsData[idx]) {
          tempSoftwareVersion = this.dlsData[idx].software_version;
        }
        if ("system_update_complete" in this.dlsData[idx]) {
          tempSystemUpdateCmplete = this.dlsData[idx].system_update_complete;
        }
        if ("system_version_time" in this.dlsData[idx]) {
          tempSystemVersionTime = this.dlsData[idx].system_version_time;
        }
        if ("software_update_ready" in this.dlsData[idx]) {
          tempSoftwareUpdateReady = this.dlsData[idx].software_update_ready;
        }
        if ("update_status" in this.dlsData[idx]) {
          tempUpdateStatus = this.dlsData[idx].update_status;
        }
        if ("update_status_timeout" in this.dlsData[idx]) {
          tempUpdateStatusTimeout = this.dlsData[idx].update_status_timeout;
        }
        if ("update_status_detil" in this.dlsData[idx]) {
          tempUpdateStatusDetail = this.dlsData[idx].update_status_detail;
        }
        if (tempSystemVersionTime !== "") {
          tempSystemVersionInfo = tempSystemVersionTime.substring(0, 10) + " ";
        }
        tempSystemVersionInfo += "(" + tempSoftwareVersion + ")";
        // 状態判定
        if (tempUpdateStatus == 0) {
          // 最新状態
          tempSystemMessage = "システムは最新です";
        } else if (tempUpdateStatus == 1) {
          // 初期状態
          if (tempUpdateStatusTimeout == -1) {
            // アップデート可能
            tempUpdateEnable = true;
          }
        } else if (tempUpdateStatus == -1) {
          // アップデート失敗
          tempStatusMessage = "アップデートに失敗しました";
          if (tempSoftwareUpdateReady) {
            tempButtonCaption = "再実行";
            tempUpdateEnable = true;
          }
        } else {
          if (tempUpdateStatusTimeout == 0) {
            tempStatusMessage = "アップデート中";
          } else if (tempUpdateStatusTimeout == 1) {
            tempStatusMessage = "アップデート中";
          } else if (tempUpdateStatusTimeout == 2) {
            tempStatusMessage = "検知システムの応答なし";
          }
        }
        let tempData = {
          id: this.dlsData[idx].dl_id,
          name: this.dlsData[idx].dl_name,
          alive: this.dlsData[idx].alive,
          update_status: tempUpdateStatus,
          update_status_detail: tempUpdateStatusDetail,
          software_update_ready: tempSoftwareUpdateReady,
          software_version: tempSoftwareVersion,
          system_version_time: tempSystemVersionTime,
          system_version_info: tempSystemVersionInfo,
          system_update_complete: tempSystemUpdateCmplete,
          button_caption: tempButtonCaption,
          button_enable: tempUpdateEnable,
          message: tempSystemMessage,
          status_message: tempStatusMessage,
          max_lines: tempMaxLines,
          barns: tempBarn
        }
        this.tableData.push(tempData);
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
div,
span {
  color: #383838;
}
</style>